<template>
	<div id="page" v-cloak>
		<mescroll-vue  ref="mescroll" :down="mescrollDown" @init="mescrollInit">
			<div class="my_money clear">
				<p class="lt">当前最多可兑换<span>{{myMoney}}元</span></p>
				<input class="rt" type="button" value="兑换记录" @click="exchangeRecord()">
			</div>
			<div class="exchange_info">
				<p class="exchange_info_title">选择兑换金额</p>
				<ul class="exchange_info_money clear">
					<li v-for="(item,index) in exchangeProductList" :class="{opt : index == present }" @click="selectMoney(index,item.Name,item.PayMoney,item.ProductId)">
						<p :class="{first_name:item.ProductId == 1}">{{item.Name}}</p>
						<p v-if="item.ProductId == 1" class="first">(仅限首次提现)</p>
					</li>
				</ul>
				<p class="exchange_money">兑换<span>{{exchangeSum}}</span>面额需要消耗</p>
				<p class="exchange_silver_coin"><span>{{money}}</span><sub>元</sub></p>
			</div>
			<div class="exchange_btn">
				<input type="button" value="确认兑换" @click="submitExchange()">
			</div>
			<div class="warm_prompt">
				温馨提示：</br>
				1.微信兑换需要先绑定微信号；</br>
				2.每个用户每天可兑换一次，兑换需要收取3%手续费；</br>
				3.审核时间为正常工作日，周末与法定节假日除外；</br>
				4.请自觉维护来啊的健康生态，禁止一切违规行为，一经查处将停止兑换行为。
			</div>
		</mescroll-vue>
		<transition name="fade">
			<div class="dialog_masking" v-if="visible" >
				<div class="dialog">
					<p class="dialog_title">提示</p>
					<div class="dialog_content" v-html="dialogContent" v-bind:class="{ dialog_content_center : textAlignCenter}"></div>
					<div class="dialog_button clear">
						<input type="button" value="取消">
						<input type="button" value="确认">
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import MescrollVue from 'mescroll.js/mescroll.vue'
	export default {
		name: 'ProfitDetails',
		components: {
			MescrollVue // 注册mescroll组件
		},
		data() {
			return {
				userId: '',
				H5Key: '',
				md5: '',
				present: 0,
				myMoney: 0,
				exchangeSum: 0,
				money: 0,
				exchangeProductList: [],
				ProductId: '',
				visible: false,
				textAlignCenter: false,
				type: [
					{'value': '钻石','code': 1},
				    {'value': '银币','code': 2},
				    {'value': '现金','code': 3},
			    ],
				mescroll: null, // mescroll实例对象
				mescrollDown:{
					callback: this.downCallback,
				},
			}
		},
		mounted() {
			if(window.LaiaJs){
				window.LaiaJs.setTitle('微信提现');
				this.userId = window.LaiaJs.getUserId();
				this.H5Key = window.LaiaJs.getH5Key();
				this.md5 = this.$md5(this.H5Key);
			}else{
				this.userId = '090405e138b74c9f9ceb397f42633c06';
				this.H5Key = 'PyPtPu4qSx1wTBYEYB4ASyWETrVsSBPv';
				this.md5 = this.$md5(this.H5Key);
			}
		},
		methods: {
			mescrollInit(mescroll) {
				this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
			},
			downCallback(page, mescroll) {
				//联网请求
				this.$axios.post("exchange/getExchangeProduct4H5.do", {
					"user_id": this.userId,
					"type": 4,
					"sign": this.md5,
				}).then((res) => {
					// console.log(res);
					if(res.data.Error != ""){
						if(window.LaiaJs){
							window.LaiaJs.showMsg(res.data.Error);
							return;
						}else{
							alert(res.data.Error);
							return;
						}
					}
					this.myMoney = res.data.Money;
					this.exchangeProductList = res.data.exchangeProductList;
					this.exchangeSum = this.exchangeProductList[0].Name;
					this.money = this.exchangeProductList[0].PayMoney;
					this.ProductId = this.exchangeProductList[0].ProductId;
					//数据渲染成功后,隐藏下拉刷新的状态
					this.$nextTick(() => {
						this.mescroll.endSuccess();
					})
				}).catch((e) => {
					//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
					this.mescroll.endErr();
				})
			},
			// 选择兑换金额
			selectMoney(index,Name,PayMoney,ProductId) {
				if (index == this.present) {
					return;
				}
				this.present = index;
				this.exchangeSum = Name;
				this.money = PayMoney;
				this.ProductId = ProductId;
			},
			// 提交兑换
			submitExchange() {
				if(parseFloat(this.myMoney) < parseFloat(this.money)){
					if(window.LaiaJs){
						window.LaiaJs.showMsg('余额不足！');
						return;
					}else{
						alert('余额不足！');
						return;
					}
				}
				this.$axios.post("exchange/submitExchange4H5.do", {
					"user_id": this.userId,
					"product_id": this.ProductId,
					"sign": this.md5,
				}).then((res) => {
					// console.log(res);
					if(res.data.Error != ""){
						if(window.LaiaJs){
							window.LaiaJs.showMsg(res.data.Error);
							return;
						}else{
							alert(res.data.Error);
							return;
						}
					}
          if(window.LaiaJs){
          	window.LaiaJs.showMsg('提现成功');
          }else{
          	alert('提现成功');
          }
					this.dataList = [];
					this.mescroll.setPageNum(1);
					this.mescroll.triggerUpScroll();
				}).catch((e) => {
					//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
					this.mescroll.endErr();
				})
			},
			exchangeRecord() {
				if(window.LaiaJs){
					window.LaiaJs.openUrl('http://laia-common.yeedian365.com/laia_h5/index.html#/ExchangeRecord');
				}else{
					this.$router.push({
					  path: '/ExchangeRecord',
					}).catch(err => {
					  // console.log(err)
					})
				}
			},
		}
	}
</script>

<style scoped>
	[v-cloak] {
		display: none;
	}
	#page {
		width: 100%;
		height: 100vh;
		background-color: #eaf1f7;
	}
	.my_money{
		padding: 0 0.48rem;
		height: 1.48rem;
		line-height: 1.48rem;
		font-size: 0.4rem;
		color: #a8a8a8;
		border-top: 0.25rem solid #eaf1f7;
		border-bottom: 1px solid #dadddf;
		background-color: #fff;
	}
	.my_money span{
		color: #3672F9;
	}
	.my_money input{
		width: 2.2rem;
		height: 0.8rem;
    line-height: 0.8rem;
		font-size: 0.36rem;
		color: #3672F9;
		border-radius: 0.1rem;
		margin: 0.34rem 0;
		border: 1px solid #3672F9;
	}
	.exchange_info{
		padding-left: 0.48rem;
		border-bottom: 1px solid #dadee2;
		background-color: #fff;
	}
	.exchange_info_title{
		font-size: 0.4rem;
		color: #404c5b;
		padding: 0.5rem 0;
	}
	.exchange_info_money{
		margin-top: 0.1rem;
	}
	.exchange_info_money li{
		float: left;
		width: 2.94rem;
		height: 1.42rem;
		line-height: 1.42rem;
		font-size: 0.44rem;
		color: #a8a8a8;
		text-align: center;
		border: 1px solid #a8a8a8;
		border-radius: 0.2rem;
		margin-right: 0.42rem;
		margin-bottom: 0.34rem;
	}
	.exchange_info_money li .first_name{
		line-height: 0.5rem;
		padding-top: 0.26rem;
	}
	.exchange_info_money li .first{
		font-size: 0.3rem;
		line-height: initial;
	}
	.exchange_info_money .opt{
		color: #fff;
		border: 1px solid #3672F9;
		background-color: #3672F9;
	}
	.exchange_money{
		font-size: 0.54rem;
		color: #404c5b;
		text-align: center;
		margin-top: 0.4rem;
		letter-spacing: 1px;
		margin-right: 0.48rem;
	}
	.exchange_money span{
		color: #3672F9;
	}
	.exchange_silver_coin{
		color: #3672F9;
		text-align: center;
		margin-top: 0.2rem;
		margin-right: 0.48rem;
		padding-bottom: 0.6rem;
	}
	.exchange_silver_coin span{
		font-size: 0.86rem;
		font-weight: bold;
	}
	.exchange_silver_coin sub{
		font-size: 0.4rem;
	}
	.exchange_btn{
		margin: 0.77rem 0.48rem 0 0.48rem;
	}
	.exchange_btn input{
		font-size: 0.4rem;
		width: 100%;
		height: 1.26rem;
		font-size: 0.4rem;
		color: #fff;
		border-radius: 0.1rem;
		background-color: #3672F9;
	}
	.warm_prompt{
		font-size: 0.3rem;
		color: #999;
		margin-top: 1.38rem;
		padding: 0 0.46rem 0 0.53rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Exchange.vue